module.exports = __webpack_public_path__ + "img/collection-memoireRingsSignature@2x.30f1623.jpg";